import { Toaster } from 'anf-core-react';
import {
  arrayOf, bool, func, string, number, shape, node,
} from 'prop-types';
import React, { useContext } from 'react';
import BreakpointContext from '../../context/breakpoint';
import Heading from '../DiscoverByFacet/Heading';

// eslint-disable-next-line no-unused-vars
import style from './FacetAndCategoryToaster.module.scss';
/**
 * FacetAndCategoryToaster component displays a sliding toaster UI element
 * that shows information related to applied facets and categories in search results.
 * The toaster slides in from the right on desktop and from the bottom on mobile.
 *
 * @component
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Content to display inside the toaster
 * @param {function} props.setToasterState - Function to update the toaster state
 * @param {object} props.toasterState - Current state of the toaster
 * @param {boolean} props.toasterState.isOpen - Whether the toaster is open
 * @param {number} [props.toasterState.count] - Optional count of selected items
 * @param {string[]} [props.toasterState.selectedFilters] - Optional array of selected filters
 * @param {string} [props.toasterHeadingPrefix] - Optional prefix for the toaster heading
 * @param {string} [props.toasterHeadingLabel] - Optional label for the toaster heading
 * @returns {JSX.Element} The rendered toaster component
 */
const FacetAndCategoryToaster = ({
  children,
  footer = [],
  setToasterState,
  toasterState,
  toasterHeadingLabel = '',
}) => {
  const { medium: tabletOrDesktop } = useContext(BreakpointContext);
  return (
    <Toaster
      direction={tabletOrDesktop ? 'from-right' : 'from-bottom'}
      footer={footer}
      heading={(
        <Heading
          toasterHeadingLabel={toasterHeadingLabel}
        />
      )}
      id="category-facet-toaster"
      isOpen={toasterState.isOpen}
      onClose={() => setToasterState({ ...toasterState, isOpen: false })}
    >
      {children}
    </Toaster>
  );
};

FacetAndCategoryToaster.propTypes = {
  children: node.isRequired,
  footer: arrayOf(node),
  toasterHeadingLabel: string,
  setToasterState: func,
  toasterState: shape({
    count: number,
    isOpen: bool,
    selectedFilters: arrayOf(string),
  }),
};

export default FacetAndCategoryToaster;
